import { useState, useEffect, useRef, useCallback } from "react";
import 'react-phone-number-input/style.css'
import Input from 'react-phone-number-input'
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import "../assets/css/modal.css";
import { setPhoneNumber, setInvalidPhoneNumber } from '../redux/data/dataSlice';
import { useDispatch } from 'react-redux';
import getCookie from "../utils/getCookie";
import 'react-phone-number-input/style.css';
import en from '../config/en.json';
import config from "../config/memberhubContents.json";

function PhoneNumber() {
  // `value` will be the parsed phone number in E.164 format.
  // Example: "+12133734253".
  const countryCodeFromCookie = getCookie();
  const [value, setValue] = useState("");
  const [country,] = useState(countryCodeFromCookie ? countryCodeFromCookie : "US");
  const dispatch = useDispatch();
  const phoneErrorRef = useRef();

  const handleError = useCallback(() => {
    const input = document.querySelector('.PhoneInputInput');
    if (value) {
      if (!isPossiblePhoneNumber(value)) {
        input.style.borderBottom = "1px solid #ff3b30";
        phoneErrorRef.current.innerHTML = config.phoneNumberError;
        dispatch(setInvalidPhoneNumber(true));
        dispatch(setPhoneNumber(""));
      } else {
        input.style.borderBottom = "1px solid #DADDDE";
        phoneErrorRef.current.innerHTML = "";
        dispatch(setInvalidPhoneNumber(false));
        console.log("Phone number: ", value);
        dispatch(setPhoneNumber(value));
      }
    } else {
      dispatch(setInvalidPhoneNumber(false));
      dispatch(setPhoneNumber(""));
      input.style.borderBottom = "1px solid #DADDDE";
      phoneErrorRef.current.innerHTML = "";
    }
  }, [dispatch, value]);

  useEffect(() => {
    const input = document.querySelector('.PhoneInputInput');
    input.addEventListener("focusout", handleError);
    return () => {
      input.removeEventListener("focusout", handleError);
    }
  }, [dispatch, handleError, value]);

  useEffect(() => {
    const input = document.querySelector('.PhoneInputCountrySelect');
    const countryCodeElement = document.querySelector('.phoneNumberInput');
    const focusCountryCodeBorder = () => {
      countryCodeElement.style.borderBottom = "1px solid #000";
    };
    const focusOutCountryCodeBorder = () => {
      countryCodeElement.style.borderBottom = "1px solid #DADDDE";
    };
    input.addEventListener("focus", focusCountryCodeBorder, false);
    input.addEventListener("focusout", focusOutCountryCodeBorder, false);
    return () => {
      input.removeEventListener("focus", focusCountryCodeBorder, false);
      input.removeEventListener("focusout", focusOutCountryCodeBorder);
    }
  }, [country]);

  return (
    <>
      <div className="w-[215px] mt-[30px]">
        <p className="self-stretch flex-grow-0 flex-shrink-0 text-xs text-left float-left text-[#4e5356]">
          Country Code
        </p>
        <p className="self-stretch flex-grow-0 flex-shrink-0  text-xs text-left float-right text-[#4e5356]">
          Phone Number
        </p>
        <p className="flex-grow-0 flex-shrink-0 text-base text-left text-black">

          <Input
            className="phoneNumberInput"
            style={{ borderBottom: "1px solid #DADDDE", float: "left" }}
            labels={en}
            defaultCountry={country}
            value={value}
            onChange={setValue}
          />
        </p>
        <p ref={phoneErrorRef} id="phoneError" className="flex self-stretch flex-grow-0 flex-shrink-0 ml-[129px] text-xs float-left w-full text-[#ff3b30] mt-1">
        </p>
      </div>
    </>
  )
}

export default PhoneNumber;
